<template>

  <nav-bar :refreshAction="true" @refresh="refresh" :shareAction="true" @share="share"   />

  <main-container>   
    <accordion-list>
      
      <template v-if="ready">
        <ModalMonthlySignature />

        <div>
          <accordion-item :id="1">
            <template v-slot:title>
              <h6 class="p-0 m-0 fw-bold">Agendamentos Hoje</h6>
              <custom-badge :amount="summary.todaySchedulings.length" />
            </template>
            <template v-slot:body>
              <list-group v-if="summary.todaySchedulings.length > 0">
                <list-item v-for="obj, index in summary.todaySchedulings" :key="index">
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">{{ obj.name }}</h6>           
                  </template>
                  <template v-slot:complement>                
                    <p class="mb-0">{{`${formatSchedulingTime(obj.startDate, obj.endDate)}`}}</p>
                  </template>
                </list-item>
              </list-group>
            
              <list-group v-else>
                <list-item>
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">{{'Nenhum agendamento para hoje ;)'}}</h6>           
                  </template>        
                </list-item>
              </list-group>  
            </template>        
          </accordion-item> 
        
          <accordion-item :id="2">
            <template v-slot:title>          
              <h6 class="p-0 m-0 fw-bold">Relatos Não Lidos</h6>          
              <custom-badge :amount="summary.unreadReports.length " />          
            </template>
            <template v-slot:body>
              <list-group v-if="summary.unreadReports.length > 0">            
                <list-item v-for="obj, index in summary.unreadReports" :key="index" v-on:click="goToReport(obj.patientId, obj.reportId, obj.name)">
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">{{ obj.title }}</h6>                
                  </template>
                  <template v-slot:info>
                    <humor-emojis :humor="obj.humor" />
                  </template>
                  <template v-slot:complement>
                    <p class="mb-0">{{ obj.name }}</p>
                  </template>
                </list-item>
              </list-group>
            
              <list-group v-else>
                <list-item>
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">Nenhum relato não lido!</h6>           
                  </template>        
                </list-item>
              </list-group>  
            </template>        
          </accordion-item> 
        
          <accordion-item :id="3">
            <template v-slot:title>
              <h6 class="p-0 m-0 fw-bold">Aniversariantes Hoje</h6>
              <custom-badge :amount="summary.birthdayPersonsToday.length" />          
            </template>
            <template v-slot:body>
              <list-group v-if="summary.birthdayPersonsToday.length > 0">
                <list-item v-for="obj, index in summary.birthdayPersonsToday" :key="index">
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">{{ obj.name }}</h6>           
                  </template>              
                </list-item>
              </list-group>
            
              <list-group v-else>
                <list-item>
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">{{'Nenhum aniversariante para hoje :('}}</h6>           
                  </template>        
                </list-item>
              </list-group>  
            </template>        
          </accordion-item>
        
          <accordion-item :id="4">
            <template v-slot:title>
              <h6 class="p-0 m-0 fw-bold">Aniversariantes Próximos 3 Dias</h6>
              <custom-badge :amount="summary.nextBirthdayPersons.length" />
            </template>
            <template v-slot:body>
              <list-group v-if="summary.nextBirthdayPersons.length > 0">
                <list-item v-for="obj, index in summary.nextBirthdayPersons" :key="index">
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">{{ obj.name }}</h6>           
                  </template>  
                  <template v-slot:complement>
                    <p class="mb-0">{{`${formatDateWithoutYear(obj.birthday)}`}}</p>
                  </template>            
                </list-item>
              </list-group>
            
              <list-group v-else>
                <list-item>
                  <template v-slot:title>
                    <h6 class="mb-1 fw-bold">{{'Nenhum aniversariante para os próximos 3 dias :('}}</h6>           
                  </template>        
                </list-item>
              </list-group>  
            </template>        
          </accordion-item>
        </div>
        
      </template>             
    </accordion-list>   
  </main-container>

  
  <bottom-bar />
    
</template>

<script>
import {formatDateWithoutYear, formatSchedulingTime} from "../../services/formatters";
import { getInstance } from "../../api/api";
import timeMixins from "../../services/time";
import { useUserStore } from '@/store/user';
import { usePatientStore } from '@/store/patient';
import ModalMonthlySignature from "../../components/Modal/ModalMonthlySignature.vue"
import { showErrorModal } from "../../services/popups";

const api = getInstance();

export default {
    name: "HomeView",
    components: {
      ModalMonthlySignature
    },
    mixins:[timeMixins],
    inject:["mySpinner"],  
    setup() {
      const userStore = useUserStore();
      const patientStore = usePatientStore();
      return  { userStore, patientStore }
    },  
    async beforeMount() {      
      this.cleanFields();      
      await this.getSummary()

      this.ready = true;
    },
    data() {
        return {
          ready:false,
          summary:{
            todaySchedulings:[1],
            unreadReports: [],
            birthdayPersonsToday: [],
            nextBirthdayPersons: []
          },          
        }
    },
    methods: {
      cleanFields() {
        this.summary = {
          todaySchedulings:[1],
          unreadReports: [],
          birthdayPersonsToday: [],
          nextBirthdayPersons: []
        }
      },
      async getSummary() {
        this.mySpinner.loading = true;

        try {
          let response = await api.get("v1/User/Summary", { params: { userId:this.userStore.getUser.id, clinicId:this.userStore.getUser.clinicId } })

          this.mySpinner.loading = false;          

          if (!response.data.success) {            
            this.cleanFields();
          }
          else {           
            this.summary = response.data.data;                       
          }          
        } catch {
          this.mySpinner.loading = false;          
        } 

      },
      convertSummary(current) {
        if (current == "todaySchedulings") {return "Agendamentos Hoje";}
        else if (current == "unreadReports") {return "Relatos Não Lidos";}
        else { return "Não Informado!"; }
      },
      goToReport(patientId, reportId, patientName) {
        this.patientStore.patient = {id:patientId, name:patientName};
        this.$router.push(`/patients/${patientId}/reports/${reportId}`)
      },
      async refresh() {
        await this.getSummary();
      },
      formatDateWithoutYear,
      formatSchedulingTime,
      share() {
        if (navigator.share) {
          navigator.share({
            title: 'Compartilhar link do App',            
            url: window.location.origin,
            icon: window.location.origin + '/img/icons/favicon-32x32.png'        
          })          
        } else {
          showErrorModal('Função de compartilhamento não suportada!');
        }
      },	
      
    },
}

</script>
